import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import posthog from 'posthog-js'
import uuid4 from 'uuid4'
import App from './app'

// if ('serviceWorker' in navigator) {
//     const s = navigator.serviceWorker
//     const url = new URL('../service-worker.js', import.meta.url)
//     s.register(url)
// }
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(new URL('../service-worker.js', import.meta.url), { type: 'module', scope: '/' })
}

if (window.location.protocol === 'https:') {
    Sentry.init({
      dsn: "https://9334b3962c7e3140050a943c6ab52c93@o4508247366107136.ingest.us.sentry.io/4508247367221248",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/wordgrid\.io/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

if (window.location.protocol === 'https:') {
    posthog.init('phc_Jt7bHCQmUWThQD4d1K9CZ4AYgLm69dPpy5zEpXyrLRg', {
        api_host: 'https://us.i.posthog.com',
        person_profiles: 'identified_only',
    })
}

let userToken = localStorage.getItem('userToken')
if (!userToken) {
    userToken = uuid4()
    localStorage.setItem('userToken', userToken)
}
posthog.identify(userToken)

const container = document.getElementById('app')

ReactDOM.render(<App />, container)
